// Whitelist for Contentful locales - needs to be in sync with the configured locale list in Contentful!
const CONTENTFUL_LOCALE_MAP: Record<string, string> = {
  cs: "cs",
  "en-US": "en-US",
  fr: "fr",
  de: "de",
  it: "it",
  ko: "ko",
  pl: "pl",
  pt: "pt",
  "pt-PT": "pt-PT",
  "pt-BR": "pt-BR",
  pt_BR: "pt-BR",
  es: "es",
};

export const CONTENTFUL_DEFAULT_LOCALE = "en";

export function mapLanguageAndCountryToContentfulLocale(
  language: string,
  country?: string
): string {
  let mappedLanguage = language;

  if (language.toLowerCase() === "pt_br") {
    mappedLanguage = "pt";
  }

  if (country) {
    const regionalKey = `${mappedLanguage}-${country.toUpperCase()}`;
    if (CONTENTFUL_LOCALE_MAP[regionalKey]) {
      return CONTENTFUL_LOCALE_MAP[regionalKey];
    }
  }

  return CONTENTFUL_LOCALE_MAP[mappedLanguage] ?? CONTENTFUL_DEFAULT_LOCALE;
}
